import React from "react";
import LinkType from "./LinkType";

const Connection = (props) => {
  const { national = true, linkTypes } = props;

  return <>{linkTypes !== "" && <LinkType national={national} linkTypes={linkTypes} key={Math.random()}/>}</>;
};

export default Connection;